import React from "react";
import chevronBlue from "../assets/images/chevron-blue.png";

export default function Pagination(props) {
  if (props.length > 1)
    return (
      <div className="pagination mt-[100px] section gap-[12px]">
        {[...Array(props.length)].map((item, i) => (
          <span key={i} className="text-lead font-medium cursor-pointer">
            <span
              className={
                i + 1 === props.selected ? "text-darkGray" : "text-blue"
              }
              onClick={() => {
                props.function(i + 1);
              }}
            >
              {i + 1}
            </span>
            {i + 1 < props.length && (
              <span
                className={
                  i + 1 === props.selected ? "text-darkGray" : "text-blue"
                }
                onClick={() => {
                  props.function(i + 1);
                }}
              >
                ,{" "}
              </span>
            )}
          </span>
        ))}
        <div
          onClick={() => {
            if (props.selected + 1 <= props.length)
              props.function(props.selected + 1);
          }}
        >
          <img className="w-[18px]" src={chevronBlue} alt="" />
        </div>
      </div>
    );
}
